/* This example requires Tailwind CSS v2.0+ */
import clsx from 'clsx';

export default function CustomPlan({
	publicMeta,
	paymentButtonOnClick,
	isPaymentProceeding,
	subscriptionDetails,
	paymentStatus,
}) {
	// const [loading, setLoading] = useState(false);
	const { custom_plan } = publicMeta;
	const planObject = {
		shopifyId: {
			monthly: { usd: custom_plan.id },
			yearly: { usd: custom_plan.id },
		},
	};

	const isCurrentPlan = () => {
		if (
			!subscriptionDetails ||
			!subscriptionDetails.id ||
			!custom_plan ||
			!custom_plan.id
		) {
			return false;
		}

		// Don't show as current plan if subscription is expired or not active
		// paymentStatus: 5 = Paid, 9 = Trial (active states)
		// paymentStatus: 6,7 = Expired, 1 = Free (inactive states)
		const activeStatuses = [5, 9, '5', '9'];
		if (paymentStatus && !activeStatuses.includes(paymentStatus)) {
			return false;
		}

		// Convert both to numbers for safe comparison (custom_plan.id is string, subscriptionDetails.id is number)
		const currentId = parseInt(subscriptionDetails.id);
		const planId = parseInt(custom_plan.id);

		// Check for valid numbers
		if (isNaN(currentId) || isNaN(planId)) {
			return false;
		}

		return currentId === planId;
	};
	return (
		<div className="bg-white shadow sm:rounded-lg">
			<div className="px-4 py-5 sm:p-6">
				<h3 className="text-lg leading-6 font-medium text-gray-900">
					{custom_plan.title}
				</h3>
				<div className="mt-2 sm:flex sm:items-start sm:justify-between">
					<div className="max-w-xl text-sm text-gray-500">
						<p>{custom_plan.price}</p>
					</div>
					<div className="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
						<button
							disabled={isPaymentProceeding || isCurrentPlan()}
							onClick={() => {
								if (!isCurrentPlan()) {
									paymentButtonOnClick(planObject);
								}
							}}
							type="button"
							className={clsx(
								'inline-flex items-center px-4 py-2 border shadow-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm',
								isCurrentPlan()
									? 'bg-gray-300 border-gray-300 text-gray-500 cursor-not-allowed'
									: 'border-transparent text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500'
							)}
						>
							{isCurrentPlan()
								? 'Current Plan'
								: isPaymentProceeding
								? 'Loading'
								: 'Subscribe'}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
